import React from 'react';
import { Link } from 'react-router-dom';
// import { showNotification } from './../../../utils';

const TemplatesP16 = (props) => {
    const renderDepartments = () => {
        if (props.fetching) {
            return <div><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
        }

        return props.departments.map((department) => {
            const imageStyle = {
                backgroundImage: 'url("' + department.image_url + '")',
                backgroundSize: 'contain',
                backgroundColor: '#dadce0',
            };

            return (
                <div className="category" key={department.id}>
                    <Link to={'/department/' + props.productId + '/' + department.id}><div className="image" style={imageStyle}></div></Link>
                    <div className="title">
                        <div className="name">{department.name}</div>
                        <div className="button-container">
                            <Link to={'/department/' + props.productId + '/' + department.id}><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            );
        });
    };

    // const handleSearch = () => {
    //     if (props.search === '') {
    //         return showNotification('Enter a value', 'Enter a text to search', 'info');
    //     }

    //     props.history.push('/search/' + props.productType + '/' + props.search);
    // };

    // const keyPressHandler = (event) => {
    //     if (event.key === 'Enter') {
    //         if (props.search === '') {
    //             return showNotification('Enter a value', 'Enter a text to search', 'info');
    //         }

    //         props.history.push('/search/' + props.productType + '/' + props.search);
    //     }
    // }

    return (
        <div className="templates-container">
            <div className="breadcrumbs">
                / <Link to="/utp">Main Categories</Link> / Marketing Collateral/Display Signage
            </div>
            {/* <div className="search-container">
                <div className="search-field">
                    <input
                        type="text"
                        placeholder="Search here..."
                        value={props.search}
                        onChange={(event) => props.setSearch(event.target.value)}
                        onKeyPress={keyPressHandler}
                    />
                    <select
                        value={props.productType}
                        onChange={(event) => props.setProductType(event.target.value)}
                    >
                        <option value="1">Cards</option>
                        <option value="17">Pocket Folders</option>
                        <option value="2">Letterheads</option>
                        <option value="3">Envelopes</option>
                        <option value="4">Notecards</option>
                        <option value="18">Notepads</option>
                        <option value="5">Forms</option>
                        <option value="7">Adult Apparel</option>
                        <option value="8">Promotional</option>
                    </select>
                    <div className="button" onClick={handleSearch}>Search</div>
                </div>
            </div> */}
            <div className="templates-row">
                {renderDepartments()}
            </div>
        </div>
    );
}

export default TemplatesP16;
